import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as backupAction from '../actions/backup.action';
import {LOAD_BACKUP, LOAD_BACKUP_NOW, LoadBackup, LoadBackupNow} from '../actions/backup.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap, switchMap} from 'rxjs/operators';
import {Utils} from "../../shared/utils/utils";
import {BackupService} from "../../websites/website/backup/backup.service";
import {Config} from "../../config/config";
import {ActivityAction, ActivityStatus} from "../../activities/activity";
import * as ongoingActivityActions from "../actions/ongoing-activities.action";
import {FinishOngoingActivity} from "../actions";
import * as websiteProductActions from "../actions/website-product.action";
import {LoadWebsiteProductsSuccess} from "../actions/website-product.action";

@Injectable()
export class BackupEffect {

  websiteProductsLoaded$ = createEffect(() => this._actions$.pipe(
    ofType(websiteProductActions.LOAD_WEBSITE_PRODUCTS_SUCCESS),
    filter((action: any): boolean => {
      const backupPluginData: any = action.payload.pluginEntities[Config.backupPluginSlug];
      if (!backupPluginData || !!action.payload.isChildWebsite) {
        return false;
      }

      const isInstalled: boolean = Utils.isTruthy(backupPluginData.installed) && Utils.isTruthy(backupPluginData.is_paid);
      const isActive: boolean = Utils.isTruthy(backupPluginData.active);
      return isInstalled && isActive;
    }),
    map((action: LoadWebsiteProductsSuccess) => {
      return new backupAction.LoadBackup(action.payload.websiteId);
    })
  ));
  afterActivateBackupPlugin$ = createEffect(() => this._actions$.pipe(
    ofType(ongoingActivityActions.FINISH_ONGOING_ACTIVITY),
    filter((action: FinishOngoingActivity): boolean =>
      (<string[]>[ActivityAction.INSTALL_ACTIVATE, ActivityAction.ACTIVATE]).includes(action.payload.entity.action)
      && action.payload.entity.status === ActivityStatus.DONE
    ),
    filter((action: FinishOngoingActivity): boolean =>
      action.payload.entity.meta.product_data.slug === Config.backupPluginSlug
    ),
    map((action: FinishOngoingActivity) => {
      return new backupAction.LoadBackup(action.payload.websiteId);
    })
  ));
  afterRunJob$ = createEffect(() => this._actions$.pipe(
    ofType(ongoingActivityActions.FINISH_ONGOING_ACTIVITY),
    filter((action: FinishOngoingActivity): boolean =>
      (<string[]>[ActivityAction.RUN_JOB]).includes(action.payload.entity.action)
      && action.payload.entity.status === ActivityStatus.DONE
    ),
    map((action: FinishOngoingActivity) => {
      return new backupAction.LoadBackup(action.payload.websiteId);
    })
  ));
  loadBackup$ = createEffect(() => this._actions$.pipe(
    ofType(LOAD_BACKUP),
    mergeMap((action: LoadBackup) => {
      return this._backupService.getDefaultBackups(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new backupAction.LoadBackupSuccess({
                websiteId: action.payload,
                entities: Utils.arrayToEntities(response.data, 'id')
              });
            }

            return new backupAction.LoadBackupFail(response.message);
          })
        );
    })
  ));
  loadBackupNow$ = createEffect(() => this._actions$.pipe(
    ofType(LOAD_BACKUP_NOW),
    switchMap((action: LoadBackupNow) => {
      const websiteId: number = action.payload.websiteId;
      const jobId: string = action.payload.jobId.id;
      return this._backupService.runJob(websiteId, jobId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new backupAction.LoadBackupNowSuccess({
                websiteId: websiteId,
                jobId: jobId,
                entities: {[websiteId]: response.data}
              });
            }

            return new backupAction.LoadBackupFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _backupService: BackupService
  ) {
  }

}
